import React from 'react'

import ListPlaceholder from 'src/ui/List/ListPlaceholder'

import TopicInfoPlaceholder from './subcomponents/TopicInfo/TopicInfoPlaceholder'
import TopicDetailSkeleton from './TopicDetailSkeleton'

const TopicDetailPlaceholder = () => (
  <TopicDetailSkeleton
    topicSection={<TopicInfoPlaceholder />}
    listSection={<ListPlaceholder />}
  />
)

export default TopicDetailPlaceholder
